import { AvailableModules } from 'generated/featureDefinitions'

import { ModuleAvailabilityType } from '../hooks/useModuleAvailability'

export const isModuleAvailabilityEnabled = (
  moduleAvailabilities: ModuleAvailabilityType[],
  module: AvailableModules
) => {
  return (
    moduleAvailabilities.find((moduleAvailability) => moduleAvailability.id === module)
      ?.available ?? false
  )
}
